import { render, staticRenderFns } from "./EditDetailPart.vue?vue&type=template&id=626f478a&scoped=true&"
import script from "./EditDetailPart.vue?vue&type=script&lang=js&"
export * from "./EditDetailPart.vue?vue&type=script&lang=js&"
import style0 from "./EditDetailPart.vue?vue&type=style&index=0&id=626f478a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626f478a",
  null
  
)

export default component.exports